var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDuplicate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M70 65v130c0 22.091 17.909 40 40 40h80v10c0 11.046-8.954 20-20 20H50c-11.046 0-20-8.954-20-20V85c0-11.046 8.954-20 20-20zm110-50v40c0 16.569 13.431 30 30 30h40v110c0 11.046-8.954 20-20 20H110c-11.046 0-20-8.954-20-20V35c0-11.046 8.954-20 20-20zm20 0 50 50h-40c-5.523 0-10-4.477-10-10z"
})));
export default SvgDuplicate;